// extracted by mini-css-extract-plugin
export default {"wrapper":"FullBlockProgress_wrapper__+09Hf"};